import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, Input } from '@nextui-org/react'
import { getBoostAction } from '../helpers/WaxApi'
import { PopupLoadingIndicator } from '../loadingindicator/PopupLoadingIndicator'
import Popup from './Popup'
import MainButton from '../common/util/input/MainButton'
import { useSharedState } from '../waxplorer/Waxplorer'
import MarketPreviewDetailsTable from '../assetpreview/MarketPreviewDetailsTable'
import { MarketInfoDetails } from '../marketinfo/MarketInfoDetails'

function BidPopup(props) {
    const auction = props['auction']

    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null
    const callBack = props['callBack']
    const closeCallBack = props['closeCallBack']

    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)

    const { t } = useTranslation('common')

    let {
        bidder,
        auctionId,
        currentBid,
        numBids,
        market,
        seller,
        assets,
        bids,
    } = auction

    for (const bid of bids) {
        if (bid.bid >= currentBid) {
            currentBid = bid.bid
            bidder = bid.bidder
        }
    }

    const name = assets[0].name
    const image = assets[0].image

    const [sellPrice, setSellPrice] = useState(
        !bidder ? currentBid : currentBid * 1.11,
    )

    const validBid = () => {
        if (!sellPrice) return false
        return sellPrice >= (!numBids ? currentBid : currentBid * 1.11)
    }

    const bid = async () => {
        if (!validBid(sellPrice)) {
            setError('Invalid Bid')
            return false
        }
        const quantity = parseFloat(sellPrice)
        setIsLoading(true)
        closeCallBack()
        try {
            const result = await activeUser.session.transact(
                {
                    actions: [
                        getBoostAction(activeUser),
                        {
                            account: 'eosio.token',
                            name: 'transfer',
                            authorization: [
                                {
                                    actor: userName,
                                    permission: activeUser.requestPermission
                                        ? activeUser.requestPermission
                                        : 'active',
                                },
                            ],
                            data: {
                                from: userName,
                                to: 'atomicmarket',
                                memo: 'deposit',
                                quantity: `${quantity.toFixed(8)} WAX`,
                            },
                        },
                        {
                            account: 'atomicmarket',
                            name: 'auctionbid',
                            authorization: [
                                {
                                    actor: userName,
                                    permission: activeUser.requestPermission
                                        ? activeUser.requestPermission
                                        : 'active',
                                },
                            ],
                            data: {
                                auction_id: auctionId,
                                bid: `${quantity.toFixed(8)} WAX`,
                                bidder: userName,
                                taker_marketplace:
                                    process.env.NEXT_PUBLIC_TESTNET === 'TRUE'
                                        ? 'nfthiveboost'
                                        : 'nft.hive',
                            },
                        },
                    ],
                },
                {
                    expireSeconds: 300,
                    blocksBehind: 0,
                },
            )

            callBack({
                success: true,
                price: quantity,
                transactionId: result?.response?.transaction_id,
            })
        } catch (e) {
            setError(e.message)
            callBack({ success: false, error: e.message ? e.message : e })
        } finally {
            setIsLoading(false)
        }
    }

    const changePrice = (e) => {
        const val = e.target.value
        if (/^\d*\.?\d*$/.test(val)) setSellPrice(val)
    }

    const cancel = () => {
        callBack({ success: false })
    }

    return (
        <Popup title={name} image={image} asset={assets[0]} cancel={cancel}>
            <div>
                <div className="relative flex flex-wrap justify-center w-full">
                    <MarketPreviewDetailsTable
                        asset={assets[0]}
                        newOwner={assets[0].owner}
                        bundleView={false}
                        showData={false}
                        className="w-full"
                    />
                    <MarketInfoDetails
                        asset={assets[0]}
                        listing={auction}
                        currentAsset={0}
                        assets={assets}
                        className="w-full my-1"
                    />
                </div>
            </div>
            <Card className="p-4">
                <div className="flex justify-center w-full mb-4 font-bold text-md">
                    {t('popups.are_you_sure_you_want_to_bid_offer_for_name', {
                        offer: `${sellPrice} WAX`,
                        name: `${name}`,
                    })}
                    ?
                </div>
                <div className="flex justify-start mb-4">
                    <Input
                        variant="faded"
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        label={t('asset.price')}
                        onChange={changePrice}
                        value={sellPrice ? sellPrice : ''}
                        className="w-full lg:w-2/3"
                    />
                </div>
            </Card>

            <div className="flex justify-start mt-3 mb-4">
                <div className="mx-2">
                    <MainButton
                        className="font-bold bg-red-500 rounded-md"
                        onClick={() => callBack({ success: false })}
                        varient={'bordered'}
                    >
                        Cancel
                    </MainButton>
                </div>
                {userName !== seller && ['atomicmarket'].includes(market) ? (
                    <div className="mx-2">
                        <MainButton
                            varient={'solid'}
                            className="font-bold rounded-md text-dark"
                            onClick={bid}
                        >
                            Bid
                        </MainButton>
                    </div>
                ) : (
                    ''
                )}
            </div>
            {isLoading ? (
                <PopupLoadingIndicator
                    text={t('popups.loading_transaction')}
                    isLoading={isLoading}
                />
            ) : (
                ''
            )}
        </Popup>
    )
}

export default BidPopup
